import type {ReleaseNote} from '@api/releases';

// The old page-wide read marker also included entries with notifications disabled.
const lastSeenKey = 'lastSeenReleaseNotification';
export const releaseNotificationSeenEvent = 'release-notification-seen';

type SeenRelease = Pick<ReleaseNote, 'id' | 'publishedAt'>;

export const hasSeenReleaseNotification = (release: SeenRelease): boolean => {
    try {
        const stored = localStorage.getItem(lastSeenKey);
        if (!stored) {
            return false;
        }

        const seen = JSON.parse(stored) as SeenRelease;
        const seenAt = Date.parse(seen.publishedAt);
        const publishedAt = Date.parse(release.publishedAt);

        return (
            seenAt > publishedAt ||
            (seenAt === publishedAt && seen.id >= release.id)
        );
    } catch {
        return false;
    }
};

export const markReleaseNotificationSeen = (release: SeenRelease): void => {
    if (hasSeenReleaseNotification(release)) {
        return;
    }

    try {
        localStorage.setItem(
            lastSeenKey,
            JSON.stringify({id: release.id, publishedAt: release.publishedAt})
        );
    } catch {
        // Release notes remain readable when browser storage is unavailable.
    }

    window.dispatchEvent(new Event(releaseNotificationSeenEvent));
};
